import { useMutation, useQueryClient } from '@tanstack/react-query';
import tourInsurancesApi from '@/features/dashboard/tourInsurances/api/tourInsurancesApi.ts';
import { tourInsurancesApiQueryKeys } from '@/features/dashboard/tourInsurances/api/tourInsurancesApi.queryKeys.ts';
import { tourInsurancesMapper } from '@/features/dashboard/tourInsurances/types/TourInsurancesDto.mapper.ts';
import { TourInsuranceFormData } from '@/features/dashboard/tourInsurances/schemas/tourInsuranceSchema.ts';
import { toast } from 'sonner';

export default function usePutTourInsurances(tourId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: TourInsuranceFormData) =>
      tourInsurancesApi.put(tourId, tourInsurancesMapper.fromFormToDto(data)),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: tourInsurancesApiQueryKeys.byTourId(tourId),
      });
      toast.success('Ustawienia ubezpieczeń zostały zapisane');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas zapisywania ubezpieczeń.',
      });
    },
  });
}
